App.namespace.wrap('es6.shared.dayjs_plugins_init', (function () {
  dayjs.extend(window.dayjs_plugin_customParseFormat);
  dayjs.extend(window.dayjs_plugin_advancedFormat);
  dayjs.extend(window.dayjs_plugin_utc);
  dayjs.extend(window.dayjs_plugin_quarterOfYear);
  dayjs.extend(window.dayjs_plugin_relativeTime);
})());
